import * as React from 'react';
import { useSelector } from 'react-redux';

import { SidebarPrice } from 'shared/components/NewbuildingGallery/components/GallerySidebar/parts';
import { PriceAuctionContainer } from 'shared/components/PriceAuction';
import { PriceDiscount } from 'shared/components/PriceDiscount';
import { PriceElectronicTrading } from 'shared/components/PriceElectronicTrading/PriceElectronicTrading';
import { getOfferDiscount } from 'shared/selectors/offerData';
import { isPriceElectronicTradingSelector } from 'shared/selectors/price';
import { selectPriceAside } from 'shared/selectors/price/selectPriceAside';
import { withNoBreakSpaces } from 'shared/utils/formatters';

export const PriceContainer: React.FC = () => {
  const price = useSelector(selectPriceAside);
  const isPriceAuction = useSelector(isPriceElectronicTradingSelector);
  const discount = useSelector(getOfferDiscount);

  if (isPriceAuction) {
    return <PriceElectronicTrading />;
  }

  if (!price) {
    return null;
  }

  const mainPrice = discount ? discount.newPrice : price;

  return (
    <>
      <PriceAuctionContainer />
      <SidebarPrice
        price={withNoBreakSpaces(mainPrice)}
        discount={discount ? <PriceDiscount oldPrice={discount.oldPrice} percent={discount.percent} /> : null}
      />
    </>
  );
};
